// extracted by mini-css-extract-plugin
module.exports = {"component":"VideoModal_component__pPbxo","iframeContainer":"VideoModal_iframeContainer__9NyEf","videoIFrame":"VideoModal_videoIFrame__OPC85"};